import { PERMISSIONS, type PermissionKey, type Scope } from '@erp/shared';

/** How the permission matrix is grouped in the role editor, with one-line help. */
export const PERMISSION_GROUPS: { title: string; items: { key: PermissionKey; help: string }[] }[] =
  [
    {
      title: 'Registros',
      items: [
        { key: 'records.view', help: 'Contactos, propiedades y negocios que puede ver.' },
        { key: 'records.edit', help: 'Registros que puede modificar.' },
        {
          key: 'records.delete',
          help: 'Registros que puede eliminar (se pueden restaurar por 30 días).',
        },
      ],
    },
    {
      title: 'Datos sensibles y publicación',
      items: [
        {
          key: 'sensitive.view',
          help: 'Documento de identidad, dirección exacta y datos de propietarios.',
        },
        { key: 'publish.web_network', help: 'Publicar propiedades en el sitio web y en la Red.' },
      ],
    },
    {
      title: 'Cierres y comisiones',
      items: [
        { key: 'closings.register', help: 'Registrar el cierre de un negocio.' },
        { key: 'commissions.view', help: 'Ver comisiones.' },
        { key: 'commissions.edit_split', help: 'Cambiar cómo se reparte una comisión.' },
        { key: 'payments.register', help: 'Registrar pagos de comisiones.' },
        { key: 'payments.approve', help: 'Aprobar pagos de comisiones.' },
      ],
    },
    {
      title: 'Reportes y datos',
      items: [
        { key: 'reports.view', help: 'Ver reportes.' },
        { key: 'data.export', help: 'Descargar datos (queda registrado en la bitácora).' },
        {
          key: 'data.import',
          help: 'Cargar contactos y propiedades desde Excel o CSV, y deshacer la carga durante 7 días.',
        },
        { key: 'collaborations.manage', help: 'Colaboraciones con otras inmobiliarias.' },
      ],
    },
    {
      title: 'Administración',
      items: [
        { key: 'users.manage', help: 'Invitar personas, cambiar roles y estados.' },
        { key: 'roles.manage', help: 'Crear y editar roles y permisos.' },
        {
          key: 'settings.manage',
          help: 'Configuración de la inmobiliaria, como el 2FA obligatorio.',
        },
        { key: 'api_keys.manage', help: 'Claves para conectar otros sistemas.' },
        {
          key: 'privacy.manage',
          help: 'Aviso de privacidad, revocaciones y solicitudes de acceso, rectificación, olvido y demás (ARCO-POL).',
        },
        {
          key: 'users.impersonate',
          help: 'Acceder como otra persona, con motivo y queda registrado.',
        },
      ],
    },
  ];

export const permissionLabel = (key: PermissionKey): string => PERMISSIONS[key].label;

export const SCOPE_LABELS: Record<Scope | 'none', string> = {
  none: 'Ninguno',
  own: 'Propios',
  team: 'Equipo',
  all: 'Todos',
};

export const STATUS_LABELS = {
  active: 'Activo',
  suspended: 'Suspendido',
  ended: 'Exmiembro',
} as const;

/** "Firefox en Linux"-style summary of a user agent (no external parser). */
export function describeUserAgent(ua: string | null): string {
  if (!ua) return 'Navegador desconocido';
  const browser = ua.includes('Edg/')
    ? 'Edge'
    : ua.includes('Firefox/')
      ? 'Firefox'
      : ua.includes('Chrome/')
        ? 'Chrome'
        : ua.includes('Safari/')
          ? 'Safari'
          : 'Navegador';
  const os = /iPhone|iPad/.test(ua)
    ? 'iPhone/iPad'
    : ua.includes('Android')
      ? 'Android'
      : ua.includes('Windows')
        ? 'Windows'
        : ua.includes('Mac OS X')
          ? 'Mac'
          : ua.includes('Linux')
            ? 'Linux'
            : 'otro sistema';
  return `${browser} en ${os}`;
}
